module.exports = __webpack_public_path__ + "static/media/user_light.06388c89.png";